import { useQueries, useQuery } from '@tanstack/react-query';

import { teamsKeys } from '~teacher/hook/team/teamsKeys';

import {
  TeamsMembersData,
  getTeamsMembers,
} from '../../../api/teams/getTeamsMembers';

const DEFAULT_TEAMS_MEMBERS_STALE_TIME = 5 * 60 * 1000; // 5 minutes in milliseconds

function teamMemberQueryOptions<T = TeamsMembersData>({
  select,
  teamId,
  enabled,
}: {
  select?: (response: TeamsMembersData) => T;
  teamId: string;
  enabled?: boolean;
}) {
  return {
    queryKey: teamsKeys.members(teamId),
    queryFn: () => getTeamsMembers(teamId),
    select: select,
    enabled: enabled ?? !!teamId,
    staleTime: DEFAULT_TEAMS_MEMBERS_STALE_TIME,
  };
}

interface UseTeamsMembersParams<T> {
  select?: (response: TeamsMembersData) => T;
  teamId: string;
  enabled?: boolean;
}

export function useTeamsMembers<T = TeamsMembersData>({
  teamId,
  select,
  enabled,
}: UseTeamsMembersParams<T>) {
  return useQuery(teamMemberQueryOptions({ teamId, enabled, select }));
}

interface UseMultipleTeamMembers<T> {
  select?: (response: TeamsMembersData) => T;
  teamIds: Array<string>;
  enabled: boolean;
}

export function useMultipleTeamMembers<T = TeamsMembersData>({
  teamIds,
  select,
  enabled,
}: UseMultipleTeamMembers<T>) {
  return useQueries({
    queries: (teamIds ?? []).map((teamId) =>
      teamMemberQueryOptions({ teamId, enabled, select })
    ),
  });
}
